<template>
  <div class="machine-card">
    <div class="machine-images">
      <div class="machine-main">
        <ImageWrapper :src="machine.imgPath" :alt="machine.name" />
      </div>
      <div v-if="machine.accessoryImage" class="machine-accessory">
        <ImageWrapper
          :src="machine.accessoryImage"
          :alt="machine.accessoryName"
        />
      </div>
      <div v-if="machine.capsuleImage" class="machine-capsule">
        <ImageWrapper :src="machine.capsuleImage" :alt="$t('recipe.capsule')" />
      </div>
    </div>
    <div class="machine-info">
      <h3 class="machine-name">{{ machine.name }}</h3>
      <p class="machine-description">{{ machine.desc }}</p>
      <p class="machine-price">{{ machine.price }}</p>
      <div class="machine-actions">
        <addToCart :id="machine.sku" :needRelpace="true" :isShow="isVisible" />
      </div>
    </div>
  </div>
</template>

<script>
import addToCart from "~/components/atoms/addToCart.vue";
import { ImageWrapper } from "~/components/";

export default {
  name: "MachineCard",
  components: {
    addToCart,
    ImageWrapper,
  },
  props: {
    isVisible: { type: Boolean, default: false },
    /**
     * Machine object containing machine information
     */
    machine: {
      type: Object,
      required: true,
      validator: (machine) => {
        return (
          machine &&
          machine.name &&
          machine.imgPath &&
          machine.price &&
          machine.desc
        );
      },
    },
  },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";

.content .app {
  .machine-card {
    display: flex;
    // flex-direction: column;
    gap: rem(24);
    // padding: rem(16);
    border-radius: rem(8);

    // @include media-breakpoint-up(md) {
    flex-direction: row;
    align-items: center;
    // }

    .machine-images {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: rem(200);
      flex-shrink: 0;
      gap: rem(34);

      @include media-breakpoint-down(md) {
        width: 30%;
        min-height: unset;
      }

      // @include media-breakpoint-up(md) {
      //   width: rem(300);
      //   height: rem(250);
      // }

      .machine-main {
        position: relative;
        z-index: 2;
        width: 100%;

        img {
          width: rem(145);
          max-height: rem(200);
          object-fit: contain;

          @include media-breakpoint-down(md) {
            max-height: rem(180);
            width: 100%;
          }
        }
      }

      .machine-accessory {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;

        img {
          max-width: rem(80);
          max-height: rem(120);
          object-fit: contain;
        }
      }

      .machine-capsule {
        position: absolute;
        bottom: rem(20);
        right: rem(20);
        z-index: 3;

        img {
          width: rem(60);
          height: rem(60);
          border-radius: 50%;
          object-fit: cover;
        }
      }
    }

    .machine-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: rem(12);

      .machine-name {
        font-family: "Nespresso Lucas", sans-serif;
        font-weight: 700;
        font-size: rem(24);
        color: color(black);
        line-height: 1.2;
        margin: 0;

        @include media-breakpoint-up(md) {
          font-size: rem(32);
        }
      }

      .machine-description {
        font-family: "Nespresso Lucas", sans-serif;
        font-weight: 400;
        font-size: rem(14);
        color: color(black);
        line-height: 1.2;
        margin: 0;

        @include media-breakpoint-up(md) {
          font-size: rem(16);
        }
      }

      .machine-price {
        font-family: "Nespresso Lucas", sans-serif;
        font-weight: 700;
        font-size: rem(18);
        color: color(black);
        letter-spacing: rem(1);
        margin: 0;

        @include media-breakpoint-up(md) {
          font-size: rem(20);
        }
      }

      .machine-actions {
        margin-top: rem(8);
        display: flex;
      }
    }
  }
}
</style>
